import { Interval, Workout } from "./Workout";


export class WorkoutViewModel
{
    Groups: IntervalGroup[] = [];
    Workout: Workout;

    constructor(workout: Workout)
    {
        this.Workout = workout;

        for (let i = 0; i < workout.Intervals.length; )
        {
            const interval = workout.Intervals[i];
            const group = this.groupInterval(i);
            this.Groups.push(group);
            i += group.Intervals.length;
        }
    }

    groupInterval(i: number): IntervalGroup
    {
        const intervals = this.Workout.Intervals;
        const maxGroupSize = 3;
        
        for (let groupSize = 1; groupSize < maxGroupSize; groupSize++)
        {
            const firstIntervals = intervals.slice(i, i + groupSize);
            const group = new IntervalGroup();
            group.Size = groupSize;
            group.Intervals.push(...firstIntervals);

            for (let j = i + groupSize; j < this.Workout.Intervals.length; j += groupSize)
            {
                const nextIntervals = intervals.slice(j, j + groupSize);
                if (this.sameIntervals(firstIntervals, nextIntervals))
                {
                    group.Intervals.push(...nextIntervals);
                }
                else
                {
                    break;
                }
            }

            if (group.Intervals.length > groupSize)
                return group;
        }

        const group = new IntervalGroup();
        group.Intervals.push(intervals[i]);
        group.Size = 1;
        return group;
    }

    sameIntervals(a: Interval[], b: Interval[]): boolean
    {
        return a.length == b.length && a.every((interval, index) => WorkoutViewModel.sameInterval(interval, b[index]));
    }

    public static sameInterval(a: Interval, b: Interval): boolean
    {
        return a.TargetCadence == b.TargetCadence && a.TargetPower == b.TargetPower && a.TotalSeconds == b.TotalSeconds;
    }

    getGroupRepetition(currentTime: number, testGroup: IntervalGroup): number
    {
        let time = 0;
        for (let group of this.Groups)
        {
            let intervalIndex = 0;

            if (currentTime < time)
                return 0;

            for (let interval of group.Intervals)
            {
                if (group == testGroup && currentTime >= time && currentTime < time + interval.TotalSeconds)
                    return Math.floor(intervalIndex / group.Size) + 1;
                time += interval.TotalSeconds;
                intervalIndex++;
            }

            if (time > currentTime)
                break;
        }

        return testGroup.Intervals.length / testGroup.Size;
    }
}
class IntervalGroup
{
    Intervals: Interval[] = [];
    Size: number = 0;
}
